import { Translator } from '@/types/translator.type';

export const HOTEL_ROOM_CATEGORIES = [
  'Classique',
  'Club',
  'Confort',
  'Deluxe',
  'Impériale',
  'Junior suite',
  'Petite',
  'Premier',
  'Prestige',
  'Romantique',
  'Standard',
  'Suite',
  'Suite Penthouse',
  'Suite Présidentielle',
  'Suite Princière',
  'Suite Royale',
  'Supérieure',
  'Tradition',
];

export const HOTEL_ROOM_COMPLEMENTARY_INFORMATION = [
  'avec balcon',
  'avec terrasse',
  'vue jardin',
  'vue mer',
  'vue montagne',
];

export const HOTEL_ROOM_CATEGORIES_TRANSLATED = (
  t: Translator,
): Record<(typeof HOTEL_ROOM_CATEGORIES)[number], string> => ({
  Classique: t('hotels.categories.classic'),
  Club: t('hotels.categories.club'),
  Confort: t('hotels.categories.comfort'),
  Deluxe: t('hotels.categories.deluxe'),
  Impériale: t('hotels.categories.imperial'),
  'Junior suite': t('hotels.categories.juniorSuite'),
  Petite: t('hotels.categories.petite'),
  Premier: t('hotels.categories.premier'),
  Prestige: t('hotels.categories.prestige'),
  Romantique: t('hotels.categories.romantic'),
  Standard: t('hotels.categories.standard'),
  Suite: t('hotels.categories.suite'),
  'Suite Penthouse': t('hotels.categories.suitePenthouse'),
  'Suite Présidentielle': t('hotels.categories.presidentialSuite'),
  'Suite Princière': t('hotels.categories.suitePrincière'),
  'Suite Royale': t('hotels.categories.suiteRoyale'),
  Supérieure: t('hotels.categories.superior'),
  Tradition: t('hotels.categories.tradition'),
});

export const HOTEL_ROOM_COMPLEMENTARY_INFORMATION_TRANSLATED = (
  t: Translator,
): Record<(typeof HOTEL_ROOM_COMPLEMENTARY_INFORMATION)[number], string> => ({
  'avec balcon': t('hotels.complementaryInformation.withBalcony'),
  'avec terrasse': t('hotels.complementaryInformation.withTerrace'),
  'vue jardin': t('hotels.complementaryInformation.gardenView'),
  'vue mer': t('hotels.complementaryInformation.seaView'),
  'vue montagne': t('hotels.complementaryInformation.mountainView'),
});
